import React from 'react';
import logo from '../../assets/logo.png';
import logo_1 from '../../assets/ymgit_image.png';

import "./Footer.css";
// get our fontawesome imports
import { faPhoneAlt,faEnvelope,} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const Footer = () => {
  return (
  <footer className="footer-dark  p-3">
    <div className="container-fluid ">
      <div className="container pt-3">
        <div className="row ">
        <a className="d-inline-block mb-2" href="index.html">
            <img src={logo} alt="AirHub"/>
          </a>
        </div>
        <div className="row col-lg-12 p-0" style={{fontSize:"0.96rem"}}>
        <div className="col-sm-8 col-xs-12 p-0">         
          <p className="py-2 pr-5" style={{fontFamily:"Roboto, Arial, sans-serif"}}>AIRHUB is a “Knowledge Centre” created by SIAA with the mission of bringing together entire eco system partners of “Automation, IoT and Robotics” to a single portal</p>
          <ul className="list-unstyled">
            <li className="mb-3">  &nbsp;
              <FontAwesomeIcon className="mr-3" icon={faPhoneAlt}/>

              <a className="" href="tel:[65] 6749 1822">[65] 6749 1822</a>
            </li>
            <li className="mb-3">   &nbsp;
            <FontAwesomeIcon className="mr-3" icon={faEnvelope}/>
            
            <a className="contact-email"  href="mailto:airhub@siaa.org">airhub@siaa.org</a>
            </li>
          


          </ul>
        </div>

        <div className=" row col-sm-4 col-xs-12">
        <div className="col-lg-12 mb-2">
            <span style={{fontSize:"22px",fontWeight:"500"}}>Links</span>
          </div>
          <div className="col-sm-6 col-xs-12">          
          <ul className="list-unstyled">
            <li className="mb-3">
              <a href="/aboutus">About Us</a>
            </li>
            <li className="mb-3">
            <a href="/signup">Sign Up</a>
            </li>
            <li className="mb-3">
              <a href="/login">Log In</a>
            </li>
            <li className="mb-3">
              <a href="/contact">Contact Us</a>
            </li>
           
          </ul>
          </div>
          <div className="col-sm-6 col-xs-12">         
          <ul className="list-unstyled">           
            <li className="mb-3">
              <a href="/faq">FAQ</a>
            </li>
            <li className="mb-3">
              <a href="/termsandconditions" style={{width:"200px"}}>Terms & Conditions</a>
            </li>
            <li className="mb-3">
              <a href="/privacypolicy">Privacy Policy</a>
            </li>
          </ul>
        </div>     
        </div>
        
        <div className='col-12'>
              <p className="mb-0">
              Copyright © 2020. All Rights Reserved by
              <a href="http://www.siaa.org/" target="_blank" rel="noopener noreferrer"> SIAA.</a>
              <center>
              <a href='https://www.ymgit.com/'>
 <img  src={logo_1} width="25px"/><span class="MyLinkText">&nbsp;Website designed & maintained by YM Global Technologies.
 </span>
 </a>
              </center>
              </p>

              </div>

        </div>       
      </div>  
    </div>
  </footer>
 );
}

export default Footer;